import type { ApiResponse, RequestOptions } from './types';
import { generatorFPV2Get } from '../swagger/easourcing/PushService';

/**
 * 获取推送token的请求参数
 */
export interface GetPushTokenParams {
  product: string;
  deviceId: string;
  appPlatform: string;
  appVersion: string;
}

/**
 * 获取推送token的响应数据
 */
export interface PushTokenData {
  fp: string;
  pipeId: string;
}

/**
 * 获取WebSocket推送token
 * @param params 请求参数
 * @param options 请求选项
 * @returns Promise<ApiResponse<PushTokenData>>
 */
export async function getPushToken(
  params: GetPushTokenParams,
  options?: RequestOptions
): Promise<ApiResponse<PushTokenData>> {
  // 根据appPlatform映射到pipeType
  let pipeType: 'ios' | 'android' | 'pc' | 'mac' | 'web' = 'web';
  switch (params.appPlatform?.toLowerCase()) {
    case 'ios':
      pipeType = 'ios';
      break;
    case 'android':
      pipeType = 'android';
      break;
    case 'pc':
    case 'windows':
      pipeType = 'pc';
      break;
    case 'mac':
    case 'macos':
      pipeType = 'mac';
      break;
    default:
      pipeType = 'web';
  }

  const result = await generatorFPV2Get({ pipeType }, options);

  return {
    code: result.code,
    message: result.message,
    data: {
      fp: result.data.fp,
      pipeId: result.data.pipeId,
    },
  };
}

/**
 * 刷新WebSocket推送token
 * @param params 请求参数
 * @param options 请求选项
 * @returns Promise<ApiResponse<PushTokenData>>
 */
export async function refreshPushToken(
  params: GetPushTokenParams,
  options?: RequestOptions
): Promise<ApiResponse<PushTokenData>> {
  // 刷新token实际上也是重新获取，所以直接调用getPushToken
  return getPushToken(params, options);
}
